module.exports = __webpack_public_path__ + "img/close.9c35715b.png";